import React from "react";
import PrivatePracticeTools, {
  PrivatePracticeToolsProps,
} from "components/PrivatePracticeTools/PrivatePracticeTools";
import Layout from "components/common/Layout";
import { SeoPageProps, getServerSideSEO } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

type PPTPageParams = { slug: string };

const PrivatePracticeToolsPage = ({ seo, title }: SeoPageProps) => {
  return (
    <Layout initialMeta={seo}>
      <PrivatePracticeTools title={title} />
    </Layout>
  );
};

export default PrivatePracticeToolsPage;

export const getServerSideProps = withEnhancedServerSideProps<
  PrivatePracticeToolsProps,
  PPTPageParams
>(async ctx => {
  const seoProps = await getServerSideSEO(ctx, "private-practice-tools");

  return {
    props: seoProps,
  };
});
